import React from "react";
import { StyledTypography } from "./styled";

export const Typography = ({
  className,
  variant = "body1",
  color = "primary",
  semibold = false,
  component,
  children,
  as,
}) => {
  const getComponent = () => {
    if (component) return component;
    if (
      variant === "h1" ||
      variant === "h2" ||
      variant === "h3" ||
      variant === "h4"
    )
      return variant;
    else return "span";
  };

  return (
    <StyledTypography
      className={className}
      as={as ?? getComponent()}
      variant={variant}
      color={color}
      semibold={semibold}
    >
      {children}
    </StyledTypography>
  );
};
